import React, { memo, Fragment } from 'react';
import { Label, Row, Col } from 'reactstrap';
import { FormInput } from '@core/components/form';
import { FormHTML } from '@core/components/form/FormHTML';
import { StatementDrillBlockVariation, StatementDrillForm } from './StatementDrillBlock';

export interface StatementDrillBlockSettingsProps {
  form: StatementDrillForm;
  variation: StatementDrillBlockVariation;
}

export const StatementDrillBlockSettings = memo((props: StatementDrillBlockSettingsProps) => {
  const { form, variation } = props;

  return (
    <div>
      <Fragment>
        <Row>
          <Col md={9}>
            <Label>Introduction</Label>
            <FormInput control={form.controls.stepTitle} />
            <FormHTML control={form.controls.statement} minimal={true} />
          </Col>
        </Row>
        <hr />
      </Fragment>
    </div>
  );
});
